import { useOrderedProductsQuery } from '../../services/orderApi'
import './orderedProducts.css'
import { AdminSkeleton, AdminEmptyState } from '../../components/ui'
import { Inventory2Outlined } from "@mui/icons-material";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000/";

function OrderdProducts(props) {
  const order_Id = props.data;
  const products = useOrderedProductsQuery(order_Id);

  if (products.isLoading) {
    return (
      <div>
        <AdminSkeleton variant="card" height={72} />
      </div>
    );
  }

  if (products.isError) {
    return (
      <AdminEmptyState
        icon={<Inventory2Outlined />}
        title="Couldn't load the ordered products"
        description="Something went wrong. Try refreshing the page."
      />
    );
  }

  return (
    <div>
      {products.data.map((data, index) => {
        const image = data.variant.images && data.variant.images[0];
        return (
          <div key={index} className="productContainer">
            <div className='imagesection'>
              {image ? <img src={`${API_BASE}${image.image}`} alt="" className='imagesection' /> : null}
            </div>
            <div className='productDetails'>
              <div className="headings">
                <span className='element'>Product Number</span>
                <span className='element'>Name</span>
                <span className='element'>Price</span>
                <span className='element'>Quantity</span>
              </div>
              <div className="data1">
                <span className='element'>{data.variant.id}</span>
                <span className='element'>{data.variant.product_name}</span>
                <span className='element'>₹{data.variant.price}</span>
                <span className='element'>{data.quantity}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  )
}

export default OrderdProducts
